import { render, staticRenderFns } from "./Responsibility.vue?vue&type=template&id=76bb0bac&scoped=true&"
import script from "./Responsibility.vue?vue&type=script&lang=js&"
export * from "./Responsibility.vue?vue&type=script&lang=js&"
import style0 from "./Responsibility.vue?vue&type=style&index=0&id=76bb0bac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76bb0bac",
  null
  
)

export default component.exports